import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Server, ArrowRight } from "lucide-react";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await register(form);
      nav(next);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="register-page" className="container-pad min-h-[80vh] py-16 flex">
      <div className="m-auto w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 mb-10">
          <span className="inline-flex h-8 w-8 items-center justify-center bg-signal text-black rounded-sm">
            <Server size={16} strokeWidth={2.5} />
          </span>
          <span className="font-display text-lg tracking-tight">
            Cloud<span className="text-signal">Rent</span>
          </span>
        </Link>
        <div className="overline">// CREATE ACCOUNT</div>
        <h1 className="mt-3 font-display text-3xl tracking-tight">Sign up for CloudRent</h1>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="label-flat">NAME</label>
            <input
              data-testid="register-name-input"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="input-flat"
              placeholder="Ada Lovelace"
            />
          </div>
          <div>
            <label className="label-flat">EMAIL</label>
            <input
              data-testid="register-email-input"
              type="email"
              autoComplete="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="input-flat"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <label className="label-flat">PASSWORD · 8+ CHARS</label>
            <input
              data-testid="register-password-input"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="input-flat"
              placeholder="••••••••"
            />
          </div>

          {err && (
            <div data-testid="register-error" className="border border-red-900/60 bg-red-950/30 text-red-300 text-sm p-3 rounded-sm font-mono">
              {err}
            </div>
          )}

          <button
            type="submit"
            data-testid="register-submit-button"
            disabled={busy}
            className="btn-signal w-full h-11 text-sm font-mono tracking-widest disabled:opacity-50"
          >
            {busy ? "CREATING…" : "CREATE ACCOUNT"} {!busy && <ArrowRight size={16} />}
          </button>

          <div className="text-center text-zinc-500 text-sm">
            Already registered?{" "}
            <Link to="/login" className="text-signal hover:underline">
              Log in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
